import {customType} from 'drizzle-orm/pg-core';
import {messageAttachment, type MessageAttachment} from './messageAttachment';

export const pgMessageAttachmentColumn = customType<{
  data: MessageAttachment;
  driverData: unknown;
}>({
  dataType() {
    return 'jsonb';
  },
  toDriver(value: MessageAttachment) {
    return JSON.stringify(value);
  },
  fromDriver(value) {
    const parsed = messageAttachment.safeParse(value);

    if (parsed.error) {
      console.error('invalid data in pgMessageAttachment', value, parsed.error);
      throw parsed.error;
    }

    return parsed.data;
  },
});
